export default {
  TITLE: 'Trust Marketing',
}
